import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, MapPin, Phone, Mail } from 'lucide-react';

const Footer = () => {
    return (
        <footer className="bg-gray-900 text-white pt-12 pb-8">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Company Info */}
                    <div>
                        <h3 className="text-xl font-bold mb-4 text-primary">Joshi Construction</h3>
                        <p className="text-gray-400 mb-4">

                            Building dreams with precision and excellence. Your trusted partner in real estate development.
                        </p>
                        <div className="flex space-x-4">
                            <a href="https://www.facebook.com/joshiconstruction" target="_blank" rel="noopener noreferrer" className="bg-gray-800 p-3 rounded-full hover:bg-primary transition-colors">
                                <Facebook size={20} />
                            </a>
                            <a href="https://www.instagram.com/joshiconstruction" target="_blank" rel="noopener noreferrer" className="bg-gray-800 p-3 rounded-full hover:bg-primary transition-colors">
                                <Instagram size={20} />
                            </a>
                        </div>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-xl font-bold mb-4 text-primary">Contact Us</h3>
                        <div className="space-y-3">
                            <div className="flex items-start">
                                <MapPin size={20} className="text-primary mr-3 mt-1 flex-shrink-0" />
                                <p className="text-gray-300">144, Revenue Colony,<br />Indore, Madhya Pradesh</p>
                            </div>
                            <div className="flex items-center">
                                <Phone size={20} className="text-primary mr-3 flex-shrink-0" />
                                <a href="tel:+919098027286" className="text-gray-300 hover:text-white transition-colors">
                                    +91 90980 27286
                                </a>
                            </div>
                            <div className="flex items-center space-x-3 text-gray-400">
                                <Mail size={18} className="text-primary" />
                                <a href="mailto:info@joshiconstruction.com" className="hover:text-primary">info@joshiconstruction.com</a>
                            </div>
                        </div>
                    </div>

                    {/* Legal / Quick Links */}
                    <div>
                        <h3 className="text-xl font-bold mb-4 text-primary">Information</h3>
                        <div className="flex flex-col space-y-2">
                            <Link to="/about" className="text-gray-400 hover:text-primary transition-colors">About Us</Link>

                        </div>
                        <p className="text-gray-500 mt-6 text-sm">
                            GST: <span className="text-gray-300">23BZXPJ5577N1ZC</span>
                        </p>
                    </div>
                </div>

                <div className="border-t border-gray-800 mt-10 pt-6 text-center text-gray-500 text-sm">
                    &copy; {new Date().getFullYear()} Joshi Construction. All rights reserved.
                </div>
            </div>
        </footer>
    );
};

export default Footer;
